import {
    delVisualManagerData,
    getVisualData,
    getHeatmapData,
    saveVirtualDeviceInfo,
    saveVisualGraphData,
    deleteVirtualDeviceInfo,
    getAvaliableDeviceData,
    saveFloorPlanData,
    deleteFloorPlanData,
    getFloorPlanProjectList,
    saveScaleData,
    getHeatmapAllData,
    getFloorPlanDetail,
    saveChannelRecommendation,
    getInteriorGraphById,
    getVirtualDeviceData,
    getVisualDataId,
    getModalVisualData
} from "./visual-data";
export const WAIT_INIT_VISUAL = "WAIT_INIT_VISUAL";
export const DO_DISPLAY_BLUEPRINT = "DO_DISPLAY_BLUEPRINT";
export const GET_VISUAL_GROUP_RSSI_INFO = "GET_VISUAL_GROUP_RSSI_INFO";
export const GET_VISUAL_GROUP_INTERIOR_GRAPH = "GET_VISUAL_GROUP_INTERIOR_GRAPH";
export const SLIDE_COEFFICIENT = "SLIDE_COEFFICIENT";
export const ADJUST_COEFFICIENT_TARGET_DEVICE = "ADJUST_COEFFICIENT_TARGET_DEVICE";
export const GET_VISUAL_MANAGER_DETAIL = "GET_VISUAL_MANAGER_DETAIL";
export const SAVE_VISUAL_MANAGER_DETAIL = "SAVE_VISUAL_MANAGER_DETAIL";
export const DELETE_VISUAL_DATA = "DELETE_VISUAL_DATA";
export const DELETE_VISUAL_DATA_SUCCESS = "DELETE_VISUAL_DATA_SUCCESS";
export const DELETE_VISUAL_DATA_FAIL = "DELETE_VISUAL_DATA_FAIL";


// get visual data
export const GET_VISUAL_LIST = "GET_VISUAL_LIST";
export const GET_VISUAL_LIST_SUCCESS = "GET_VISUAL_LIST_SUCCESS";
export const GET_VISUAL_LIST_FAIL = "GET_VISUAL_LIST_FAIL";

export const GET_VISUAL_LIST_ALL = "GET_VISUAL_LIST_ALL";
export const GET_VISUAL_LIST_ALL_SUCCESS = "GET_VISUAL_LIST_ALL_SUCCESS";
export const GET_VISUAL_LIST_ALL_FAIL = "GET_VISUAL_LIST_ALL_FAIL";

export const GET_VISUAL_MANAGER_MODAL = "GET_VISUAL_MANAGER_MODAL";
export const GET_VISUAL_MANAGER_MODAL_SUCCESS = "GET_VISUAL_MANAGER_MODAL_SUCCESS";
export const GET_VISUAL_MANAGER_MODAL_FAIL = "GET_VISUAL_MANAGER_MODAL_FAIL";

// floor plan
export const GET_FLOOR_PLAN_DATA = "GET_FLOOR_PLAN_DATA";
export const SAVE_FLOOR_PLAN_DATA = "SAVE_FLOOR_PLAN_DATA";
export const SAVE_FLOOR_PLAN_DATA_SUCCESS = "SAVE_FLOOR_PLAN_DATA_SUCCESS";
export const SAVE_FLOOR_PLAN_DATA_FAIL = "SAVE_FLOOR_PLAN_DATA_FAIL";
export const DELETE_FLOOR_PLAN = "DELETE_FLOOR_PLAN";
export const DELETE_FLOOR_PLAN_SUCCESS = "DELETE_FLOOR_PLAN_SUCCESS";
export const DELETE_FLOOR_PLAN_FAIL = "DELETE_FLOOR_PLAN_FAIL";
export const FILTER_FLOOR_PLAN = "FILTER_FLOOR_PLAN";
export const PRE_CHANGE_FLOOR_PLAN = "PRE_CHANGE_FLOOR_PLAN";
export const CONTINUE_TO_CHANGE_FLOOR_PLAN = "CONTINUE_TO_CHANGE_FLOOR_PLAN";
export const END_CHANGING_FLOOR_PLAN = "END_CHANGING_FLOOR_PLAN";
export const DO_SELECT_FLOOR_PLAN_PROJECT = "DO_SELECT_FLOOR_PLAN_PROJECT";
export const DO_GET_FLOOR_PLAN_PROJECT_LIST = "DO_GET_FLOOR_PLAN_PROJECT_LIST";
export const DO_GET_FLOOR_PLAN_PROJECT_LIST_SUCCESS = "DO_GET_FLOOR_PLAN_PROJECT_LIST_SUCCESS";
export const DO_GET_FLOOR_PLAN_PROJECT_LIST_FAIL = "DO_GET_FLOOR_PLAN_PROJECT_LIST_FAIL";
export const SET_FLOOR_PLAN_PROJECT_LIST = "SET_FLOOR_PLAN_PROJECT_LIST";
export const GET_VISUAL_LIST_ID_SUCCESS = "GET_VISUAL_LIST_ID_SUCCESS";
export const GET_VISUAL_LIST_ID_FAIL = "GET_VISUAL_LIST_ID_FAIL";
export const GET_FLOOR_PLAN_DETAIL_SUCCESS = "GET_FLOOR_PLAN_DETAIL_SUCCESS";
export const GET_FLOOR_PLAN_DETAIL_FAIL = "GET_FLOOR_PLAN_DETAIL_FAIL"
export const RESET_FLOOR_PLAN_DATA = "RESET_FLOOR_PLAN_DATA"
export const GET_VISUAL_LIST_ID = "GET_VISUAL_LIST_ID"
export const GET_FLOOR_PLAN_DETAIL = "GET_FLOOR_PLAN_DETAIL"
// get heatmap data
export const GET_HEATMAP_DATA = "GET_HEATMAP_DATA";
export const GET_HEATMAP_DATA_SUCCESS = "GET_HEATMAP_DATA_SUCCESS";
export const GET_HEATMAP_DATA_FAIL = "GET_HEATMAP_DATA_FAIL";

export const GET_HEATMAP_ALL_DATA = 'GET_HEATMAP_ALL_DATA';
export const GET_HEATMAP_ALL_DATA_SUCCESS = 'GET_HEATMAP_ALL_DATA_SUCCESS';
export const GET_HEATMAP_ALL_DATA_FAIL = 'GET_HEATMAP_ALL_DATA_FAIL';

// save wall data
export const SAVE_GRAPH_DATA = "SAVE_GRAPH_DATA";
export const SAVE_GRAPH_DATA_SUCCESS = "SAVE_GRAPH_DATA_SUCCESS";
export const SAVE_GRAPH_DATA_FAIL = "SAVE_GRAPH_DATA_FAIL";

// save scale data
export const SAVE_SCALE_DATA_SUCCESS = "SAVE_SCALE_DATA_SUCCESS";
export const SAVE_SCALE_DATA_FAIL = "SAVE_SCALE_DATA_FAIL";
export const SAVE_SCALE_DATA = "SAVE_SCALE_DATA";

// save channel recommendation
export const SAVE_CHANNEL_RECOMMENDATION_SUCCESS = "SAVE_CHANNEL_RECOMMENDATION_SUCCESS";
export const SAVE_CHANNEL_RECOMMENDATION_FAIL = "SAVE_CHANNEL_RECOMMENDATION_FAIL";
export const SAVE_CHANNEL_RECOMMENDATION = "SAVE_CHANNEL_RECOMMENDATION";

// get interior graph
export const GET_INTERIOR_GRAPH = "GET_INTERIOR_GRAPH";
export const GET_INTERIOR_GRAPH_SUCCESS = "GET_INTERIOR_GRAPH_SUCCESS";
export const GET_INTERIOR_GRAPH_FAIL = "GET_INTERIOR_GRAPH_FAIL";

export const GET_AVAILABLE_DEVICE_DATA = "GET_AVAILABLE_DEVICE_DATA";
export const GET_AVAILABLE_DEVICE_DATA_SUCCESS = "GET_AVAILABLE_DEVICE_DATA_SUCCESS";
export const GET_AVAILABLE_DEVICE_DATA_FAIL = "GET_AVAILABLE_DEVICE_DATA_FAIL";

export const GET_VIRTUAL_DEVICE_DATA = "GET_VIRTUAL_DEVICE_DATA";
export const GET_VIRTUAL_DEVICE_DATA_SUCCESS = "GET_VIRTUAL_DEVICE_DATA_SUCCESS";
export const GET_VIRTUAL_DEVICE_DATA_FAIL = "GET_VIRTUAL_DEVICE_DATA_FAIL";

// virtual device
export const SAVE_VIRTUAL_DEVICE_INFO = "SAVE_VIRTUAL_DEVICE_INFO";
export const SAVE_VIRTUAL_DEVICE_INFO_SUCCESS = "SAVE_VIRTUAL_DEVICE_INFO_SUCCESS";
export const SAVE_VIRTUAL_DEVICE_INFO_FAIL = "SAVE_VIRTUAL_DEVICE_INFO_FAIL";
export const DELETE_VIRTUAL_DEVICE = "DELETE_VIRTUAL_DEVICE";
export const DELETE_VIRTUAL_DEVICE_SUCCESS = "DELETE_VIRTUAL_DEVICE_SUCCESS";
export const DELETE_VIRTUAL_DEVICE_FAIL = "DELETE_VIRTUAL_DEVICE_FAIL";
export const BIND_VIRTUAL_DEVICE = "BIND_VIRTUAL_DEVICE";
export const BIND_VIRTUAL_DEVICE_SUCCESS = "BIND_VIRTUAL_DEVICE_SUCCESS";
export const BIND_VIRTUAL_DEVICE_FAIL = "BIND_VIRTUAL_DEVICE_FIAL";

export const doGetVisualData = (authToken, projectSeq) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getVisualData(resolve, reject, authToken, projectSeq);
    });

    doPost
        .then((data) => {
            if ('success' === data.responseMsg) {
                dispatch({
                    type: GET_VISUAL_LIST_SUCCESS,
                    params: {
                        visualList: data.data[0]
                    }
                });
            } else {
                dispatch({
                    type: GET_VISUAL_LIST_FAIL,
                    params: {
                        message: data.message
                    }
                });
            }
        }).catch((err) => {
            dispatch({
                type: GET_VISUAL_LIST_FAIL,
                params: {
                    message: err
                }
            });
        });

    dispatch({
        type: GET_VISUAL_LIST
    });
}

export const doGetVisualDataId = (authToken, projectSeq) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getVisualDataId(resolve, reject, authToken, projectSeq);
    });

    doPost
        .then((data) => {
            if ('success' === data.responseMsg) {
                dispatch({
                    type: GET_VISUAL_LIST_ID_SUCCESS,
                    params: {
                        visualListId: data.data[0],
                        graphId: data.data[0].mappingGroups[0].id,
                    }
                });

            } else {
                dispatch({
                    type: GET_VISUAL_LIST_ID_FAIL,
                    params: {
                        message: data.message,
                    }
                });
            }
        }).catch((err) => {
        dispatch({
            type: GET_VISUAL_LIST_ID_FAIL,
            params: {
                message: err.toString()
            }
        });
    });

    dispatch({
        type: GET_VISUAL_LIST_ID
    });
}

export const doGetFloorDetail = (authToken, floorId) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getFloorPlanDetail(resolve, reject, authToken, floorId);
    });

    doPost
        .then((data) => {
            if ('success' === data.responseMsg) {
                dispatch({
                    type: GET_FLOOR_PLAN_DETAIL_SUCCESS,
                    params: {
                       floorPlanData: data
                    }
                });
            } else {
                dispatch({
                    type: GET_FLOOR_PLAN_DETAIL_FAIL,
                    params: {
                        message: data.message
                    }
                });
            }
        }).catch((err) => {
        dispatch({
            type: GET_FLOOR_PLAN_DETAIL_FAIL,
            params: {
                message: err.toString(),
            }
        });
    });

    dispatch({
        type: GET_FLOOR_PLAN_DETAIL
    });
}

export const resetFloorData = () => (dispatch) => {
    dispatch({
        type: RESET_FLOOR_PLAN_DATA,
    })
}

export const getFloorPlanData = (data) => (dispatch) => {
    dispatch({
        type: GET_FLOOR_PLAN_DATA,
        params: {
            floorPlan: data
        }
    });
}

export const doSaveFloorPlanData = (data, token) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        saveFloorPlanData(resolve, reject, data, token);
    });
    doPost.then((data) => {
        if (data.responseMsg === 'success') {
            dispatch({
                type: SAVE_FLOOR_PLAN_DATA_SUCCESS
            })
        } else {
            dispatch({
                type: SAVE_FLOOR_PLAN_DATA_FAIL,
                params: { errMsg: data.responseMsg }
            })
        }
    }).catch((err) => {
        dispatch({
            type: SAVE_FLOOR_PLAN_DATA_FAIL
        })
    })
    dispatch({
        type: SAVE_FLOOR_PLAN_DATA,
    })
}


export const doDeleteFloorPlanData = (seq, token) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        deleteFloorPlanData(resolve, reject, seq, token);
    });
    doPost.then((data) => {
        if (data.responseMsg === 'success') {
            dispatch({
                type: DELETE_FLOOR_PLAN_SUCCESS
            })
        } else {
            dispatch({
                type: DELETE_FLOOR_PLAN_FAIL
            })
        }
    }).catch((err) => {
        dispatch({
            type: DELETE_FLOOR_PLAN_FAIL
        })
    })
    dispatch({
        type: DELETE_FLOOR_PLAN,
    })
}



export const getVisualGroupRSSIAction = (virtualDeviceInfo, mappingOrg, mappingGroup, mappingInteriorGraph, wallInfo) => (dispatch) => {
    dispatch({
        type: GET_VISUAL_GROUP_RSSI_INFO,
        params: {
            mappingOrg: mappingOrg,
            mappingGroup: mappingGroup,
            virtualDeviceInfo: virtualDeviceInfo,
            mappingInteriorGraph: mappingInteriorGraph,
            wallInfo: wallInfo
        }
    });
}

export const getVisualGroupInteriorGraphAction = (interiorGraphImgUrl, interiorGraphImgWidth, interiorGraphImgUrlDetail) => (dispatch) => {
    dispatch({
        type: GET_VISUAL_GROUP_INTERIOR_GRAPH,
        params: {
            interiorGraphImgUrl: interiorGraphImgUrl,
            interiorGraphImgWidth: interiorGraphImgWidth,
            interiorGraphImgUrlDetail: interiorGraphImgUrlDetail
        }
    });
}

export const doDisplayBlueprint = (isDisplay) => (dispatch) => {
    dispatch({
        type: DO_DISPLAY_BLUEPRINT,
        params: {
            displayBlueprint: isDisplay
        }
    });
}


export const dispathVisualMangerDetail = (managerDetailData) => (dispatch) => {
    dispatch({
        type: GET_VISUAL_MANAGER_DETAIL,
        params: {
            managerDetailData: managerDetailData
        }
    });
}

export const doGetModalVisualData = (authToken, requestBody) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getModalVisualData(resolve, reject, authToken, requestBody);
    });
    doPost.then((data) => {
        if (data.responseMsg === 'success') {
            dispatch({
                type: GET_VISUAL_MANAGER_MODAL_SUCCESS,
                params: {
                    managerDetail: data.data
                }
            })
        } else {
            dispatch({
                type: GET_VISUAL_MANAGER_MODAL_FAIL
            })
        }
    }).catch((err) => {
        dispatch({
            type: GET_VISUAL_MANAGER_MODAL_FAIL
        })
    })
    dispatch({
        type: GET_VISUAL_MANAGER_MODAL,
    });
}

export const dispatchSaveVisualManager = (info, confirm) => (dispatch) => {
    dispatch({
        type: SAVE_VISUAL_MANAGER_DETAIL,
        params: {
            info: info,
            confirm: confirm
        }
    });
}

export const doDeleteVisualData = (requestBody, token) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        delVisualManagerData(resolve, reject, requestBody, token);
    });
    doPost.then((data) => {
        if (data.status === 'success') {
            dispatch({
                type: DELETE_VISUAL_DATA_SUCCESS
            })
        } else {
            dispatch({
                type: DELETE_VISUAL_DATA_FAIL
            })
        }
    }).catch((err) => {
        dispatch({
            type: DELETE_VISUAL_DATA_FAIL
        })
    })
    dispatch({
        type: DELETE_VISUAL_DATA,
    })
}


export const doGetHeatmapData = (requestBody, authToken) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getHeatmapData(resolve, reject, requestBody, authToken);
    });
    doPost.then((data) => {
        if (data.status.code === 200) {
            dispatch({
                type: GET_HEATMAP_DATA_SUCCESS,
                // result data has haetmap : {"base64_str", "height", "width", "data_type"}, "runTimeSec"
                params: {
                    heatmapData: data.result.heatmap,
                    channels: data.result?.auto_channel_recommend?.wt ?? []
                }
            })
        } else {
            dispatch({
                type: GET_HEATMAP_DATA_FAIL,
                // errMsg: data.status.message
            })
        }
    }).catch((err) => {
        dispatch({
            type: GET_HEATMAP_DATA_FAIL
        })
    })
    dispatch({
        type: GET_HEATMAP_DATA,
    })
}

export const doGetHeatmapAllData = (authToken, projectId, graphId, formData) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getHeatmapAllData(resolve, reject, authToken, projectId, graphId, formData);
    });
    doPost.then((data) => {
        if ('success' === data.responseMsg) {
            dispatch({
                type: GET_HEATMAP_ALL_DATA_SUCCESS,
                params: {
                    heatmapAllData: data.result.heatmaps
                }
            })
        } else {
            dispatch({
                type: GET_HEATMAP_ALL_DATA_FAIL,
                // errMsg: data.status.message
            })
        }
    }).catch((err) => {
        dispatch({
            type: GET_HEATMAP_ALL_DATA_FAIL
        })
    })
    dispatch({
        type: GET_HEATMAP_ALL_DATA,
    })
}


export const doGetAvaliableDeviceData = (token, groupId, siteId) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getAvaliableDeviceData(resolve, reject, token, groupId, siteId);
    });
    doPost.then((data) => {
        if (data.responseMsg === 'success') {
            dispatch({
                type: GET_AVAILABLE_DEVICE_DATA_SUCCESS,
                params: {
                    deviceList: data.data
                }
            })
        } else {
            dispatch({
                type: GET_AVAILABLE_DEVICE_DATA_FAIL,
            })
        }
    }).catch((err) => {
        dispatch({
            type: GET_AVAILABLE_DEVICE_DATA_FAIL
        })
    })
    dispatch({
        type: GET_AVAILABLE_DEVICE_DATA,
    })
}

export const doGetVirtualDeviceData = (token, graphId) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getVirtualDeviceData(resolve, reject, token, graphId);
    });
    doPost.then((data) => {
        if (data.responseMsg === 'success') {
            dispatch({
                type: GET_VIRTUAL_DEVICE_DATA_SUCCESS,
                params: {
                    deviceVirtual: data.devices
                }
            })
        } else {
            dispatch({
                type: GET_VIRTUAL_DEVICE_DATA_FAIL,
            })
        }
    }).catch((err) => {
        dispatch({
            type: GET_VIRTUAL_DEVICE_DATA_FAIL
        })
    })
    dispatch({
        type: GET_AVAILABLE_DEVICE_DATA,
    })
}

export const doSaveVisualGraphData = (token, wallData, id, lineLength, scaleLine, deviceData, channelRecommendationConfig) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        saveVisualGraphData(resolve, reject, token, wallData, id, lineLength, scaleLine, deviceData, channelRecommendationConfig);

    });
    doPost.then((data) => {
        if (data.responseMsg === 'success') {
            dispatch({
                type: SAVE_GRAPH_DATA_SUCCESS,
            })
        } else {
            dispatch({
                type: SAVE_GRAPH_DATA_FAIL,
            })
        }
    }).catch((err) => {
        dispatch({
            type: SAVE_GRAPH_DATA_FAIL
        })
    })
    dispatch({
        type: SAVE_GRAPH_DATA,
    })
}

export const doSaveScaleData = (token, id, lineLength, scaleLine) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        saveScaleData(resolve, reject, token, id, lineLength, scaleLine);

    });
    doPost.then((data) => {
        if (data.responseMsg === 'success') {
            dispatch({
                type: SAVE_SCALE_DATA_SUCCESS,
            })
        } else {
            dispatch({
                type: SAVE_SCALE_DATA_FAIL,
            })
        }
    }).catch((err) => {
        dispatch({
            type: SAVE_SCALE_DATA_FAIL
        })
    })
    dispatch({
        type: SAVE_SCALE_DATA
    })
}

export const doSaveChannelRecommendation = (token, id, channelRecommendationConfig) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        saveChannelRecommendation(resolve, reject, token, id, channelRecommendationConfig);
    });
    doPost.then((data) => {
        if (data.responseMsg === 'success') {
            dispatch({
                type: SAVE_CHANNEL_RECOMMENDATION_SUCCESS,
            })
        } else {
            dispatch({
                type: SAVE_CHANNEL_RECOMMENDATION_FAIL,
            })
        }
    }).catch((err) => {
        dispatch({
            type: SAVE_CHANNEL_RECOMMENDATION_FAIL
        })
    })
    dispatch({
        type: SAVE_CHANNEL_RECOMMENDATION
    })
}

export const doGetInteriorGraph = (token, id) => (dispatch) => {
    let doGet = new Promise((resolve, reject) => {
        getInteriorGraphById(resolve, reject, token, id);
    });
    doGet.then((data) => {
        if (data) {
            dispatch({
                type: GET_INTERIOR_GRAPH_SUCCESS,
                data,
            })
        }
    }).catch((err) => {
        dispatch({
            type: GET_INTERIOR_GRAPH_FAIL
        })
    })
    dispatch({
        type: GET_INTERIOR_GRAPH
    })
}

export const doSaveVirtualDeviceInfo = (authToken, requestBody, graphId) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        saveVirtualDeviceInfo(resolve, reject, authToken, requestBody, graphId);
    });
    doPost.then((data) => {
        if (data.responseMsg === 'success') {
            dispatch({
                type: SAVE_VIRTUAL_DEVICE_INFO_SUCCESS,
            })
        } else {
            dispatch({
                type: SAVE_VIRTUAL_DEVICE_INFO_FAIL,
                // errMsg: data.status.message
            })
        }
    }).catch((err) => {
        dispatch({
            type: SAVE_VIRTUAL_DEVICE_INFO_FAIL
        })
    })
    dispatch({
        type: SAVE_VIRTUAL_DEVICE_INFO,
    })
} 

export const doDeleteVirtualDeviceInfo = (authToken, virtualDeviceId) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        deleteVirtualDeviceInfo(resolve, reject, authToken, virtualDeviceId);
    });
    doPost.then((data) => {
        if (data.responseMsg === 'success') {
            dispatch({
                type: DELETE_VIRTUAL_DEVICE_SUCCESS,
            })
        } else {
            dispatch({
                type: DELETE_VIRTUAL_DEVICE_FAIL,
                // errMsg: data.status.message
            })
        }
    }).catch((err) => {
        dispatch({
            type: DELETE_VIRTUAL_DEVICE_FAIL
        })
    })
    dispatch({
        type: DELETE_VIRTUAL_DEVICE,
    })
} 

export const filterFloorPlan = (seq, value) => (dispatch) =>{
    dispatch({
        type: FILTER_FLOOR_PLAN,
        params: {
            graphId: seq,
            graphValue: value
        }
    });
}

export const preChangeFloorPlan = (nextFloorPlanId) => (dispatch) =>{
    dispatch({
        type: PRE_CHANGE_FLOOR_PLAN,
        params: {
            nextFloorPlanId: nextFloorPlanId,
        }
    });
}

export const continueToChangeFloorPlan = () => (dispatch) =>{
    dispatch({
        type: CONTINUE_TO_CHANGE_FLOOR_PLAN,
    });
}

export const endChangingFloorPlan = () => (dispatch) =>{
    dispatch({
        type: END_CHANGING_FLOOR_PLAN,
    });
}

export const doSelectFloorPlanProject  = (projectSeq, environment, address) => (dispatch) => {
    localStorage.setItem("projectSeq", projectSeq);
    localStorage.setItem("environment", environment);
    localStorage.setItem("address", address ?? "");
    dispatch({
        type: DO_SELECT_FLOOR_PLAN_PROJECT,
        params: {
            selectFloorPlanProject: projectSeq,
            selectFloorPlanProjectEnvironment: environment,
            projectAddress: address,
        }
    })
}

export const setFloorPlanProjectList = (data) => (dispatch) => {
    dispatch({
        type: SET_FLOOR_PLAN_PROJECT_LIST,
        params: {
            floorPlanProjectList: data
        }
    })
}

export const doGetFloorPlanProjectList = (token, site) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getFloorPlanProjectList(resolve, reject, token, site);
    });
    doPost.then((data) => {
        if (data.responseMsg === 'success') {
            dispatch({
                type: DO_GET_FLOOR_PLAN_PROJECT_LIST_SUCCESS,
                params: {
                    floorPlanProjectList: data.data
                }
            })
            localStorage.setItem("floorPlanProjectList", JSON.stringify(data.data));
        } else {
            dispatch({
                type: DO_GET_FLOOR_PLAN_PROJECT_LIST_FAIL
            })
        }
    }).catch((err) => {
        dispatch({
            type: DO_GET_FLOOR_PLAN_PROJECT_LIST_FAIL
        })
    })
    dispatch({
        type: DO_GET_FLOOR_PLAN_PROJECT_LIST,
    })
}
